export const INSTAGRAM = "https://www.instagram.com/reisingerandres/";
export const TWITTER = "https://twitter.com/reisingerandres";
export const MAIN_WEB = "https://reisinger.studio/";
export const REISINGER_MAIL_CONTACT = "info@reisinger.studio";
export const REISINGER_MAIL_PRESS = "press@reisinger.studio";
